import { render, staticRenderFns } from "./ArtworkApprovalFilters.vue?vue&type=template&id=79d83418&scoped=true"
import script from "./ArtworkApprovalFilters.vue?vue&type=script&lang=js"
export * from "./ArtworkApprovalFilters.vue?vue&type=script&lang=js"
import style0 from "./ArtworkApprovalFilters.vue?vue&type=style&index=0&id=79d83418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d83418",
  null
  
)

export default component.exports